var map = {
	"./goldcoin/task-detail-arrow2.png": 18814,
	"./memetown/task-detail-arrow2.png": 29789,
	"./reflection/task-detail-arrow2.png": 24154,
	"./tapcoin/task-detail-arrow2.png": 88161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94870;